import { gql } from '@apollo/client';
export const GET_AUTH_TOKEN_ADMIN = gql`
  query GET_AUTH_TOKEN_ADMIN($input: CustomerAuthTokenInput!) {
    getAuthTokenAdmin(input: $input) {
      token
    }
  }
`;